<template>
  <div class="about">
    <div class="aboutCenter">
      <div class="left">
        <p class="p1" :title="About.title">{{ About.title }}</p>
        <p class="p2" :title="About.describe">
          <span v-html="About.describe"></span>
        </p>
        <p
          class="p3 wow animated fadeInUp"
          data-wow-duration="2s"
          data-wow-delay=".5"
        >
          ABOUT US
        </p>
      </div>
      <div
        class="right wow animated fadeInUp"
        data-wow-duration="2.2s"
        data-wow-delay=".5"
      >
        <img :src="JJImg.qrcode" alt="" />
      </div>
      <div class="bottom">
        <div class="bottomCenter">
          <div class="Btm1">
            <p class="BtmLP1">{{ About.bord_one_title }}</p>
            <p class="BtmLP2">
              {{ About.bord_one_number }}
              <!-- <span>位</span> -->
            </p>
          </div>
          <div class="Btm2">
            <p class="BtmRP1">{{ About.bord_two_title }}</p>
            <p class="BtmRP2">
              {{ About.bord_two_number }}
              <!-- <span>年</span> -->
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { GetHF, GetIndex_Show } from "@/https/http";
export default {
  data() {
    return {
      top: "",
      About: "",
      JJImg: "",
    };
  },
  created() {
    GetHF({}).then((res) => {
      this.About = res.result;
      // console.log("this.About", this.About);
    });
    GetIndex_Show().then((res) => {
      // console.log("GetIndex_Show", res.result);
      this.JJImg = res.result;
    });
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
  methods: {
    windowScroll() {
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 0) {
        this.top = scrollTop;
        parseInt(this.top);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.windowScroll);
  },
};
</script>
<style lang="scss" scoped>
@media screen and(min-width: 1020px){
  .about {
    width: 100%;
    min-width: 1427px;
    height: 937px;
    position: relative;
    margin: 0 auto;
    .aboutCenter {
      width: 1427px;
      min-width: 1427px;
      height: 677px;
      margin: 0 auto;
      .left {
        float: left;
        height: 235px;
        .p1 {
          // width: 242px;
          height: 22px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          margin-top: 270px;
        }
        .p2 {
          width: 586px;
          /* height: 107px; */
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 30px;
          margin-top: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          height:220px;
          -webkit-line-clamp: 7;
          -webkit-box-orient: vertical;
        }
        .p3 {
          width: 1115px;
          height: 157px;
          font-size: 200px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #f7f7f7;
          line-height: 30px;
          /* margin-top: 92px; */
          position: relative;
          top: 110px;
          left: 0;
        }
      }
      .right {
        position: relative;
        img {
          position: absolute;
          top: 181px;
          right: 0;
          z-index: 1;
          width: 680px;
          height: 756px;
        }
      }
      .bottom {
        min-width: 1427px;
        width: 100%;
        height: 260px;
        background: #ff8229;
        position: absolute;
        z-index: -1;

        top: 677px;
        left: 0;
        .bottomCenter {
          width: 1427px;
          margin: 0 auto;
        }
        .Btm1 {
          float: left;
          margin-top: 84px;
          .BtmLP1 {
            margin-bottom: 10px;
            width: 64px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 30px;
          }
          .BtmLP2 {
            width: 153px;
            font-size: 50px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
            > span {
              width: 15px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              line-height: 30px;
              margin-left: -15px;
            }
          }
        }
        .Btm2 {
          float: left;
          margin-top: 94px;
          margin-left: 174px;
          .BtmRP1 {
            width: 64px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            margin-bottom: 10px;
          }
          .BtmRP2 {
            width: 153px;
            font-size: 50px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;

            > span {
              width: 15px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              line-height: 30px;
              margin-left: -15px;
            }
          }
        }
      }
    }
  }
}
* {
  margin: 0;
  padding: 0;
}
@media screen and(max-width:1020px){
  .about{
    width: 100%;
    // height: 980px;
    position: relative;
    margin: 0 auto;
  }
  .aboutCenter{
    width: 100%;
    // height: 677px;
    margin: 0 auto;
    

    .left{
      width: 100%;
      // height: 235px;
      padding-left:20px;
      padding-right:20px;
      box-sizing: border-box;

      .p1{
          height: 22px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          margin-top:40px;
      }
      .p2 {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 30px;
          margin-top: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          height:220px;
          -webkit-line-clamp: 7;
          -webkit-box-orient: vertical;
        }
        .p3{
          margin-top:25px;
          height: 80px;
          font-size: 70px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #f7f7f7;
          line-height: 30px;
          text-align: center;
          width: 100%;
        }
      }
      .right {
        width:100%;
        padding-left:20px;
        padding-right:20px;
        box-sizing: border-box;
        img {
          width: 100%;
        }
      }
      .bottom {
        width: 100%;
        margin-top:-5px;
        // height: 260px;
        background: #ff8229;
        padding-left:20px;
        padding-right:20px;
        box-sizing: border-box;
        .bottomCenter {
          width:100%;
          height: 260px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .Btm1 {
          .BtmLP1 {
            margin-bottom: 10px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 30px;
          }
          .BtmLP2 {
            width: 153px;
            font-size: 50px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
            > span {
              width: 15px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              line-height: 30px;
              margin-left: -15px;
            }
          }
        }
        .Btm2 {
          .BtmRP1 {
            width: 64px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            margin-bottom: 10px;
          }
          .BtmRP2 {
            width: 153px;
            font-size: 50px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;

            > span {
              width: 15px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              line-height: 30px;
              margin-left: -15px;
            }
          }
        }
      }
  }
}

</style>